<template>
  <div>
    <CDataTable
      v-bind="options"
      :items="items"
      :loading="loading"
      :show-empty="true"
      :bordered="true"
    >
      <template
        :slot="slot"
        slot-scope="data, item"
        v-for="slot in options.slots"
      >
        <slot
          :name="slot"
          :value="data.value"
          :index="data.index"
          :item="data.item"
        ></slot>
      </template>
      <template slot="no-items-view">
        <span style="color:#969696;">Danh sách trống!</span>
      </template>
      <template slot="loading">
        <BaseLoading :loading="loading"/>
      </template>
    </CDataTable>
    <div v-if="pagination && pagination.totalElement !== 0">
      <div style="display:flex; flex-wrap:wrap;">
        <div style="font-size:.95em;color:gray; padding-left:.75rem;">
          {{ fromElement }}-{{ toElement }} /
          {{ this.pagination.totalElement }} bản ghi
        </div>
        <nav style="margin-left:auto;">
          <CPagination
            @update:activePage="updateActivePage"
            :activePage.sync="pagination.activePage"
            :pages="pagination.pages"
            :total-rows="pagination.totalRows"
            :per-page="pagination.pageSize"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
import BaseLoading from "./BaseFormLoading";

export default {
  components: {BaseLoading},
  props: ["options", "dataSource"],
  inheritAttrs: false,
  data() {
    var that = this;
    return {
      loading: false,
      items: [],
      pagination: {
        activePage: 1,
        pages: 1,
        pageSize: 10,
        totalElement: 1
      }
    };
  },
  methods: {
    setupPagination(_dataResponse) {
      this.pagination.pages = Math.ceil(
        _dataResponse.totalElement / this.pagination.pageSize
      );
      this.pagination.totalElement = _dataResponse.totalElement;
    },
    updateActivePage: function (activePage) {
      this.pagination.activePage = activePage;
      this.loadData(true);
    },
    loadData(isNavPaging) {
      this.loading = true;

      var that = this;
      var _dataSource = Object.assign({}, this.dataSource);
      var _dataSubmit = _dataSource.dataSubmit ? _dataSource.dataSubmit() : {};

      if (_dataSource.dataRef) {
        _dataSubmit = this.$helper.setupDataSubmit(_dataSource.dataRef);
      }
      if (!isNavPaging && this.pagination) {
        this.pagination.activePage = 1;
      }
      if (this.pagination) {
        _dataSubmit.pageNumber = this.pagination.activePage - 1;
        _dataSubmit.pageSize = this.pagination.pageSize;
      }
      _dataSource.dataSubmit = function () {
        return _dataSubmit;
      };
      _dataSource.successCallback = function (response) {
        let dataResponse = response.data;
        if (that.$helper.validResponse(that.$router, dataResponse)) {
          var _dataResponse = _dataSource.response(dataResponse);
          that.items = that.pagination
            ? _dataResponse.list
              ? _dataResponse.list.content
              : _dataResponse.dataContent.content
            : _dataResponse[_dataSource.resultListAttrName];
          if (that.pagination) {
            that.setupPagination(_dataResponse);
          }
        }
        that.loading = false;
      };

      _dataSource.errorCallback = function (error) {
        that.loading = false;
        that.$helper.handleError(that.$router, error);
      };
      this.$helper.loadDataSource(_dataSource);
    }
  },
  created() {
    this.pagination = this.options.noPaging ? false : this.pagination;
    if (this.pagination && this.options.pageSize) {
      this.pagination.pageSize = this.options.pageSize;
    }
  },
  mounted() {
    if (!(this.options && this.options.lazyLoad === false)) {
      this.loadData();
    }
  },
  updated() {
  },
  computed: {
    getTotalElementByPage: function () {
      if (!this.pagination) {
        return 1;
      }
      return (this.pagination.activePage - 1) * this.pagination.pageSize + 1;
    },
    fromElement: function () {
      return (this.pagination.activePage - 1) * this.pagination.pageSize + 1;
    },
    toElement: function () {
      return (
        (this.pagination.activePage - 1) * this.pagination.pageSize +
        this.items.length
      );
    }
  },
  watch: {}
};
</script>
<style scoped></style>
